var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospitalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1734_7933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.418 8.39453L15.2091 8.93186C16.3535 9.2752 16.9256 9.44686 17.2551 9.8897C17.5846 10.3325 17.5846 10.9299 17.5846 12.1246V18.3945",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.75391 7.5625H9.25391M6.75391 10.8958H9.25391",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.0846 18.3971V15.8971C10.0846 15.1115 10.0846 14.7186 9.84055 14.4746C9.59647 14.2305 9.20364 14.2305 8.41797 14.2305H7.58464C6.79896 14.2305 6.40613 14.2305 6.16204 14.4746C5.91797 14.7186 5.91797 15.1115 5.91797 15.8971V18.3971",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.75391 18.3945H18.4206",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.58594 18.3971V5.6615C2.58594 3.56921 2.58594 2.52306 3.24525 2.004C3.90458 1.48495 4.87545 1.76676 6.8172 2.33039L10.9839 3.53982C12.1556 3.87995 12.7415 4.05 13.0804 4.51351C13.4193 4.97703 13.4193 5.60834 13.4193 6.87095V18.3971",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1734_7933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0859375 0.0625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalIcon);
export default __webpack_public_path__ + "static/media/hospital-icon.0fc48ea1bc24b3eb8b3396ee4183a1b8.svg";
export { ForwardRef as ReactComponent };